import { selectLocationSearch, useLocationSelector } from '@react-router';

const useQueryString = (): string => {
  return useLocationSelector(selectLocationSearch);
};

export default useQueryString;
